import React, {useState} from 'react';

import {Button, CreateIcon, DeleteIcon, SmallLoader} from '@kit';

import {getApolloError} from '../../components/utils';
import {useDeleteConfirm} from '../../components/use-delete-confirm';
import {useCharacterSheetsQuery, useDeleteCharacterSheetMutation} from '../../generated/types';
import {Link} from '../../lib/routes';
import {CreationMaster} from './character/master/creation-master';
import {SheetSummary, useTitleLookups} from './sheet-summary';

import css from './sheets.module.css';

export const SheetList: React.FC = () => {
	const {data, loading, error, refetch} = useCharacterSheetsQuery({ssr: false, fetchPolicy: 'cache-and-network'});
	const [deleteSheet] = useDeleteCharacterSheetMutation();
	const [isCreating, setCreating] = useState(false);
	const {openConfirm, DeleteConfirm} = useDeleteConfirm({
		title: 'Удалить бланк персонажа?',
		callback: async (sheetId: string) => {
			await deleteSheet({variables: {id: sheetId}});
			await refetch();
		},
	});

	const closeCreation = () => {
		setCreating(false);
		refetch();
	};

	const sheets = data?.characterSheets || [];
	const titles = useTitleLookups();

	return (
		<div className={css.page}>
			<header className={css.header}>
				<h1>Бланки персонажей</h1>
				<Button appearance="primary" icon={<CreateIcon />} onClick={() => setCreating(true)}>
					Создать персонажа
				</Button>
			</header>

			{error && <div className={css.message}>{getApolloError(error).message}</div>}
			{loading && !data && <SmallLoader />}
			{data && !sheets.length && <p className={css.muted}>У вас пока нет персонажей.</p>}

			<ul className={css.sheetList}>
				{sheets.map((sheet) => (
					<li key={sheet.id} className={css.sheetCard}>
						<Link route="sheet" params={{id: sheet.id}} className={css.sheetLink}>
							<span className={css.sheetName}>{sheet.name || 'Безымянный персонаж'}</span>
							<SheetSummary sheet={sheet} titles={titles} />
						</Link>
						<Button
							appearance="subtle"
							icon={<DeleteIcon />}
							aria-label="Удалить"
							title="Удалить"
							onClick={() => openConfirm(sheet.id)}
						/>
					</li>
				))}
			</ul>

			<CreationMaster open={isCreating} onClose={closeCreation} />
			{DeleteConfirm}
		</div>
	);
};
